const initialState = { opened: true };
export default function reducer(state = initialState, action) {
  switch (action.type) {
    case "INIT":
      return { ...state, ...action.category };
    case "TOGGLE":
      return { ...state, opened: !state.opened };
    default:
      return state;
  }
}
